import React from 'react'

const EmptyVeille = () => {

	return (
		<div className='w-screen h-screen bg-black flex justify-center items-center'>
      <div className='uppercase font-bold text-3xl text-white animate-pulse'>
        click or tap on the screen...
      </div>
    </div>
	)
}

export default EmptyVeille;